import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalizationService } from '../../modules/localization/localization.service';
import { HOME_MASTER_ROUTE } from '../../modules/main/main.data';
import { IIcon } from '../../modules/shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../modules/shared/components/icon/icons-sizes.enum';
import {
  supportUrlsLocalized,
  URLS,
} from '../../modules/shared/constants/urls.constant';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent implements OnInit, AfterViewInit {
  homeRoute: string[];
  invoice2goLogo: IIcon;
  helperText: string;
  invoice2goUrl: string;

  constructor(
    private _localizationService: LocalizationService,
    private _translateService: TranslateService,
    @Inject(DOCUMENT) private _document: Document
  ) {}

  ngOnInit() {
    this.homeRoute = [HOME_MASTER_ROUTE];
    this.invoice2goUrl = URLS.INVOICE2GO;
    this.invoice2goLogo = {
      name: 'invoice2go-logo-white',
      size: IconSizesEnum.custom,
    };

    const supportUrl = supportUrlsLocalized(
      URLS.SUPPORT,
      this._localizationService.getLocale()
    );

    this.helperText = this._translateService.instant(
      'ERROR.PAGE_NOT_FOUND.NEED_HELP',
      {
        url: supportUrl,
      }
    );
  }

  ngAfterViewInit() {
    this._document.body.classList.add('loaded');
  }
}
